import { createFileRoute } from "@tanstack/react-router"
import { QuestionnairePage } from "@/questionnaire"

// The respondent questionnaire flow — magic-link invitations land here
export const Route = createFileRoute("/(user)/r/$assignmentId")({
  component: RouteComponent,
})

function RouteComponent() {
  const { assignmentId } = Route.useParams()

  return <QuestionnairePage assignmentId={assignmentId} />
}
